export var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["DeFacto"] = "DE_FACTO";
    MaritalStatus["Divorced"] = "DIVORCED";
    MaritalStatus["Married"] = "MARRIED";
    MaritalStatus["Single"] = "SINGLE";
    MaritalStatus["Unknown"] = "UNKNOWN";
})(MaritalStatus || (MaritalStatus = {}));
//# sourceMappingURL=MaritalStatus.js.map